import React from 'react'
import PropTypes from 'prop-types'

import ResultItemCompact from './ResultItemCompact'

class VideoSelectorCompact extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      active: false,
      search: '',
    }

    this.renderResultList = this.renderResultList.bind(this)
  }

  componentDidMount() {
    const { performSearch } = this.props
    performSearch('')
  }

  renderResultList() {
    const { results, toggleItem } = this.props
    return results.map((result, idx) => (
      <ResultItemCompact
        // eslint-disable-next-line react/no-array-index-key
        key={idx}
        {...result}
        onClick={() => {
          toggleItem(result)
        }}
      />
    ))
  }

  render() {
    const {
      theme,
      getPlaceholder,
      performSearch,
      setSelectionToResults,
      selectionCount,
    } = this.props
    const { active, search } = this.state
    const className = `video-selector video-selector-compact theme-${theme} ${
      active ? 'active' : ''
    }`

    return (
      <div className={className}>
        <input
          type="text"
          className="search-input"
          placeholder={getPlaceholder()}
          value={search}
          onChange={(e) => {
            this.setState({ search: e.target.value })
            performSearch(e.target.value)
          }}
          onFocus={() => {
            this.setState({ active: true })
          }}
          onBlur={() => {
            this.setState({ active: false, search: '' })
            setSelectionToResults()
          }}
        />
        <div
          className="result-list"
          onMouseDown={(e) => {
            e.preventDefault()
          }}
        >
          <div className="result-list-inner">{this.renderResultList()}</div>
        </div>
        <div className="selection-count">{selectionCount}</div>
      </div>
    )
  }
}

VideoSelectorCompact.propTypes = {
  getPlaceholder: PropTypes.func,
  performSearch: PropTypes.func,
  results: PropTypes.arrayOf(PropTypes.object),
  selectionCount: PropTypes.number.isRequired,
  toggleItem: PropTypes.func,
  setSelectionToResults: PropTypes.func,
  theme: PropTypes.oneOf(['light', 'dark']),
}

export default VideoSelectorCompact
